module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-2ad25c35.png";